<!-- Banner End -->

<div class="el-banner-wrapper" style="overflow: hidden;">
    <div class="container">
        <div class="el-banner-parent">
            <div class="el-banner-flex">
                <div class="el-banner-left">

                    <!-- <img src="../assets/images/all-instructor/star-smile111.png" class="el-star-smile" alt="star"
                        style="position: relative;">
                    <h1>
                        <span class="word">Schitt<span class="superscript">s</span> </span>
                        <span class="word">Creek</span>
                    </h1> -->
                    <h1 class=""><span class="word"><span class="">A</span>ce Your Journey <br> from <span
                                style="color: #51007c;" class="">P</span>ractice to
                            <span style="color: #51007c;" class="">P</span>erfection</span>

                    </h1>
                    <p class="el-para word2">Attain perfection with online mock test papers - to build confidence
                        that compels toward
                        a successful career. A resource aiding
                        to boost your confidence, sharpen your competitive skills, and drive you towards a bright,
                        successful future.
                    </p>
                    <div class="el-banner-btns justify-content-start">
                        <!-- <div class="el-banner-play-icon">
                            <a class="video-popup" href="https://youtu.be/D0UnqGm_miA?si=M-FnoMWqNdepVQqz">
                                <span>
                                    <svg width="16" height="19" viewBox="0 0 16 19">
                                        <path
                                            d="M15.5467 8.67162L1.32444 0.121637C1.18929 0.040615 1.03668 -0.00130209 0.881723 3.08244e-05C0.726761 0.00136374 0.574808 0.0459005 0.440889 0.129237C0.306634 0.212869 0.195261 0.332685 0.117894 0.476718C0.0405275 0.62075 -0.000123954 0.783957 2.83917e-07 0.950036V18.05C-0.000123954 18.2161 0.0405275 18.3793 0.117894 18.5233C0.195261 18.6674 0.306634 18.7872 0.440889 18.8708C0.577033 18.9551 0.731537 18.9997 0.888889 19C1.03822 19 1.18933 18.9601 1.32444 18.8784L15.5467 10.3284C15.8258 10.1593 16 9.84392 16 9.50002C16 9.15612 15.8258 8.84072 15.5467 8.67162Z" />
                                    </svg>
                                </span>
                                <h5 class="ms-3">play video</h5>
                            </a>
                        </div> -->
                        <!-- <a href="#about" class="el-btn">get started</a> -->

                    </div>

                    <div class="el-banner-box">
                        <!-- <img src="../assets/images/all-instructor/banner-arrow2.svg" alt="Arrow Shape"> -->

                        <div class="el-banner-form-flex d-flex justify-content-center align-items-center">
                            <div class="el-banner-form-info col">
                                <h4><span>&nbsp;Step 1 &nbsp;</span></h4>
                                <h5> Register
                                </h5>


                            </div>
                            <div class="el-banner-form-info col">
                                <h4><span>&nbsp;Step 2 &nbsp;</span></h4>
                                <h5> Login

                                </h5>

                            </div>
                            <div class="el-banner-form-info col">
                                <h4><span>&nbsp;Step 3 &nbsp;</span></h4>
                                <h5> Attempt Test
                                </h5>

                            </div>
                            <div class=" mt-0 col">

                                <a [routerLink]="['/dashboard']" class="el-btn">get started</a>
                            </div>
                        </div>

                    </div>
                    <span [routerLink]="['/dashboard']" style="cursor: pointer;">
                        <div class="el-video-box">
                            <img src="../assets/images/all-instructor/w1.png" alt="Icon">
                            <div class="el-video-content">
                                <h6 class="mb-2"><b style="font-size: 24px;">1st</b> Mock Test </h6>
                                <h4 class="wave-text">
                                    <span>F</span><span>R</span><span>E</span><span>E</span>
                                </h4>
                                <!-- <h4>FREE</h4> -->
                            </div>
                        </div>
                    </span>
                    <img src="../assets/images/all-instructor/banner-arrow111.png" class="el-arrow1" alt="Arrow Left">
                </div>
                <div class="el-banner-right">
                    <div class="el-banner-reslt-box">
                        <img src="../assets/images/all-instructor/star-smile.png" class="el-star-smile" alt="star">
                        <h4>Toppers</h4>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r1.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4>Kiaan Goswamy
                                </h4>
                                <p>iOEL English Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>85%</span>
                            </div>
                        </div>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r2.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4> Chandranshu</h4>
                                <p>iOM Mathematics Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>90%
                                </span>
                            </div>
                        </div>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r3.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4>Pranav</h4>
                                <p>iOS Science Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>92%</span>
                            </div>
                        </div>
                    </div>
                    <div class="el-banner-img mt-5">
                        <img src="assets/images/all-instructor/about22.png" alt="banner girl">
                    </div>
                    <div class="banner-img-bg-circle" id="banner-img-bg-circle">
                        <img src="assets/images/all-instructor/banner-img-bg-circle.png" alt="banner-img-bg-circle"
                            class="img-fluid">
                    </div>
                    <div class="banner-img-bg-circle2" id="banner-img-bg-circle2">
                        <img src="assets/images/all-instructor/banner-img-bg-circle.png" alt="banner-img-bg-circle2"
                            class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Banner Start -->

<!-- Counter Start -->
<div class="el-counter-wrapper">
    <div class="container">
        <div class="el-counter-parent">
            <img src="../assets/images/all-instructor/students.png" alt="students">
            <div class="el-count  text-center">
                <div class="el-counting" data-to="2,22,000">0</div>
                <div class="el-count-heading">
                    <h4 class="">Success Stories</h4>
                </div>
            </div>
            <div class="el-count  text-center">
                <div class="el-counting" data-to="6,500">0</div>
                <div class="el-count-heading">
                    <h4 class="">Expert Instructors</h4>
                </div>
            </div>
            <div class="el-count  text-center">
                <div class="el-counting" data-to="5,000">0</div>
                <div class="el-count-heading">
                    <h4 class="">Active Students</h4>
                </div>
            </div>
            <div class="el-count  text-center">
                <div class="el-counting" data-to="2,000">0</div>
                <div class="el-count-heading">
                    <h4 class="">Hours Video Classes</h4>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Counter End -->

<!-- About Section Start -->
<div class="el-about-wrapper" id="about">
    <div class="container">
        <div class="row gy-4 align-items-center">
            <div class="col-lg-6">
                <div class="el-about-img">
                    <div class="el-banner-reslt-box">
                        <h4>Brilliant Results</h4>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r5.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4>Aarav Dsouza</h4>
                                <p>iOEL English Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>97%</span>
                            </div>
                        </div>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r6.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4>Tanay Pradip</h4>
                                <p>iOM Mathematics Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>84%</span>
                            </div>
                        </div>
                        <div class="el-reslt-flex">
                            <img src="../assets/images/all-instructor/r7.png" alt="student image">
                            <div class="el-reslt-info">
                                <h4>Surbhi Priya</h4>
                                <p>iOS Science Olympiad</p>
                            </div>
                            <div class="el-reslt-grade">
                                <span>93%</span>
                            </div>
                        </div>
                    </div>
                    <img src="../assets/images/all-instructor/about1.png" alt="About Image">

                    <img src="../assets/images/all-instructor/about-video-icon.png" alt="Video Icon"
                        class="el-abt-videoIcon">
                    <img src="../assets/images/all-instructor/star-smile.png" alt="Video Icon" class="el-smile-star">
                </div>

            </div>
            <div class="col-lg-6">
                <div class="el-about-content">
                    <h4 class="el-top-heading">Benefits</h4>
                    <h2 class="el-main-heading">Unlock the perfect prep plan with a series of targeted mock tests!!
                    </h2>
                    <p class="el-para">Power Prep offers the best solution to prepare for Olympiads. Focused with
                        multiple mock tests of subjects ranging from
                        Maths, English and Science. Offering the chance to practice, learn and conquer the success
                        in
                        Olympiads.</p>
                    <p class="el-para">With Mock Tests - get the best series of benefits - focusing on assessing the
                        strength and weakness required for
                        preparing for Olympiads.
                    </p>
                    <ul>
                        <li class="el-para">
                            <i class="fa fa-check-circle"></i>
                            Empowers with Practice

                        </li>
                        <li class="el-para">
                            <i class="fa fa-check-circle"></i>
                            Attain Time Management

                        </li>
                        <li class="el-para">
                            <i class="fa fa-check-circle"></i>
                            Enhance Retention and Recall

                        </li>
                        <li class="el-para">
                            <i class="fa fa-check-circle"></i>
                            Stimulates Real-Time Experience

                        </li>
                        <li class="el-para">
                            <i class="fa fa-check-circle"></i>
                            Boosts Competitive Edge for Success

                        </li>
                    </ul>
                    <!-- <a href="javascript:;" class="el-btn">read more</a> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About Section End -->

<!-- plan Section Start -->
<app-plans></app-plans>
<!-- plan Section End -->

<!-- course Section Start -->
<!-- <app-course></app-course> -->

<!-- course Section End -->

<!-- enroll Section Start -->

<!-- enroll Section End -->
<app-enroll-now></app-enroll-now>

<!-- enroll Section End -->
<!-- buy-book Section start -->
<app-buy-book></app-buy-book>
<!-- buy-book Section End -->

<!-- Testimonial Section Start -->

<app-testimonials></app-testimonials>

<!-- Testimonial Section End -->